import { Text, Input, Box, Button } from "@chakra-ui/react";
import React, { useState } from "react";
import subscribe from "../../services/subscribe";
import { t } from "i18next";

export const EmailSignUp = () => {
  const [email, setEmail] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      await subscribe(email);
      setError(null);
      setSuccess(true);
    } catch (error) {
      console.error("Error:", error);
      setError(t("game.gameSummary.somethingWentWrong"));
    }
  };

  return (
    <Box
      w={{ base: "100%", md: "60%" }}
      height="120px"
      display="flex"
      flexDirection="column"
      alignItems="center"
    >
      <Text color="white" mt={10} fontSize="lg" textAlign="center">
        {t("game.gameSummary.joinFrequentFlyer")}
      </Text>
      <form
        onSubmit={handleSubmit}
        style={{
          width: "100%",
          display: success ? "none" : "flex",
          justifyContent: "center",
        }}
      >
        <Box display="flex" mt={4} width={{ base: "100%", md: "60%" }}>
          <Input
            type="email"
            placeholder={t("game.gameSummary.emailPlaceholder")}
            backgroundColor="white"
            color="black"
            height="45px"
            borderRadius="8px"
            borderRightRadius={0}
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
          <Button
            type="submit"
            height="44px"
            borderRadius="8px"
            borderLeftRadius={0}
            background="green.600"
          >
            {t("game.gameSummary.joinButton")}
          </Button>
        </Box>
      </form>
      {error && (
        <Text color="white" mt={4} fontSize="sm">
          {error}
        </Text>
      )}
      {success && (
        <Text color="white" mt={4} fontSize="sm">
          {t("game.gameSummary.thanksForSubscribing")}
        </Text>
      )}
    </Box>
  );
};
